import { Component, OnInit } from '@angular/core';
import { INotification, NotificationsService } from '@core/components/notifications/notifications.service';
import { Permission } from '@core/enums/permission.enum';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { initOptionsSelectors } from '@store/app/init-options/init-options.selectors';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  protected readonly permissions = [Permission.PERM_DOCUMENTS_INVOICES];

  protected readonly isUiVersion$ = this._store
    .select(initOptionsSelectors.uiVersion)
    .pipe(map((version) => ['arval'].includes((version || '').toLowerCase())));

  protected readonly badgeHidden$ = this._notificationsService.badgeHidden$;
  protected readonly unreadCount$ = this._notificationsService.unreadCount$;
  protected readonly isEmpty$ = this._notificationsService.isEmpty$;

  protected readonly notifications$ = this._notificationsService.notifications$;

  protected isOpen = false;

  constructor(
    private _notificationsService: NotificationsService,
    private _store: Store
  ) {}

  ngOnInit(): void {
    this._notificationsService.openTrigger$.pipe(untilDestroyed(this)).subscribe(() => (this.isOpen = true));
  }

  dropdownOnToggle(): void {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      setTimeout(() => this._notificationsService.markAllAsRead());
    }
  }

  onRemoveNotify(notify: INotification): void {
    setTimeout(() => notify.removeFn());
  }
}
